// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__vq_wS","productName":"Table_productName__PSep-"};